import React from 'react';
import { HeartFilled } from '@ant-design/icons';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <div className="footer-content">
                <div className="footer-left">
                    <span>© {currentYear} </span>
                    <strong>TIGOON Connect</strong>
                    <span> - Tous droits réservés</span>
                </div>
                <div className="footer-right">
                    <span>Fait avec </span>
                    <HeartFilled style={{ color: '#E07D3B', margin: '0 4px' }} />
                    <span> en Côte d'Ivoire</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
